// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Noto+Sans:wght@700&family=Poppins:wght@300;400;500;600&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.verification-container
{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin : 0px 20%;
    margin-top : 80px;
    background-color: #00468D;
    border-radius: 10px;
    padding: 30px 20px;
}

.verification-title
{
    color: white;
    text-align: center;
    font-size: 26px;
    font-weight: 500;
    margin-bottom : 20px;
    margin-top : 10px;
}

.verification-text
{
    width : 80%;
    color: white;
    text-align: center;
    margin-bottom: 40px;
    font-size : 17px;
}

.verification-code
{
    padding : 3px 10px;
    color: #001E60;
    font-weight: 500;
    width : 250px;
}

.verification-code-container
{
    display: flex;
    align-items: center;
    margin-bottom : 40px;
}

.verification-security-text
{
    color: white;
    font-weight : 500;
    font-size : 16px;
    margin-right : 12px;
}

.verification-no-code
{
    color: white;
    margin-bottom : 20px;
    text-align: center;
}

.verification-link
{
    margin-left : 10px;
    text-decoration: underline;
    text-underline-offset: 2px;
    transition: 300ms ease;
}

.verification-link:hover
{
    color: orange;
}

.verification-problems-container
{
    margin-top : 80px;
    color : white;
    align-items: center;
    margin-bottom : 60px;
    display: flex;
    justify-content: center;
    flex-direction: column;
}

.verification-problems-title
{
    font-size : 20px;
    font-weight: 500;
    margin-bottom : 30px;
    text-align: center;
}

.verification-problems-link
{
    text-align: center;
    font-weight: 600;
    padding : 10px 20px;
    background-color: #ecaa1e;
    color: #001E60;
    border-radius: 10px;
    transition: 300ms ease;
}

.verification-problems-link:hover 
{
    background-color:#001E60;
    color: white;
}


input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button 
{
  -webkit-appearance: none;
  margin: 0;
}

@media all and (max-width : 1000px)
{
    .verification-container
    {
    margin : 0px 8%;
    margin-top : 60px;
    }

    .verification-text
    {
        width: 90%;
    }
}

@media all and (max-width : 540px)
{
    .verification-container
    {
    margin : 0px 6%;
    margin-top : 40px;
    }

    .verification-text
    {
        width: 95%;
    }
}

@media all and (max-width : 480px)
{

    .verification-container
    {
        margin : 0px 5%;
        margin-top : 30px;
    }

    .verification-title
    {
        font-size: 20px;
    }

    .verification-text
    {
        width: 90%;
        font-size: 15px;
    }

    .verification-code-container
    {
        flex-direction: column;
    }

    .verification-code
    {
        width : 220px
    }

    .verification-security-text
    {
        margin-right : 0px;
        margin-bottom : 20px;
    }

    .verification-no-code
    {
        display: flex;
        align-items: center;
        flex-direction: column;
        font-size: 13px;
    }

    .verification-link
    {
        margin-left: 0px;
        margin-top: 5px;
    }

    .verification-problems-container
    {
        margin-top: 40px;
        margin-bottom : 40px;
    }

    .verification-problems-title
    {
        font-size: 18px;
    }

    .verification-problems-link
    {
        font-size: 14px;
        padding: 8px 15px;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/account/verify.css"],"names":[],"mappings":"AAEA;;IAEI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;;IAEI,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;;IAEI,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,aAAa;AACjB;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;;IAEI,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;;IAEI,YAAY;IACZ,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;;IAEI,kBAAkB;IAClB,0BAA0B;IAC1B,0BAA0B;IAC1B,sBAAsB;AAC1B;;AAEA;;IAEI,aAAa;AACjB;;AAEA;;IAEI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,aAAa;IACb,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;;IAEI,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;;IAEI,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;;IAEI,wBAAwB;IACxB,YAAY;AAChB;;;AAGA;;;EAGE,wBAAwB;EACxB,SAAS;AACX;;AAEA;;IAEI;;IAEA,eAAe;IACf,iBAAiB;IACjB;;IAEA;;QAEI,UAAU;IACd;AACJ;;AAEA;;IAEI;;IAEA,eAAe;IACf,iBAAiB;IACjB;;IAEA;;QAEI,UAAU;IACd;AACJ;;AAEA;;;IAGI;;QAEI,eAAe;QACf,iBAAiB;IACrB;;IAEA;;QAEI,eAAe;IACnB;;IAEA;;QAEI,UAAU;QACV,eAAe;IACnB;;IAEA;;QAEI,sBAAsB;IAC1B;;IAEA;;QAEI;IACJ;;IAEA;;QAEI,kBAAkB;QAClB,oBAAoB;IACxB;;IAEA;;QAEI,aAAa;QACb,mBAAmB;QACnB,sBAAsB;QACtB,eAAe;IACnB;;IAEA;;QAEI,gBAAgB;QAChB,eAAe;IACnB;;IAEA;;QAEI,gBAAgB;QAChB,oBAAoB;IACxB;;IAEA;;QAEI,eAAe;IACnB;;IAEA;;QAEI,eAAe;QACf,iBAAiB;IACrB;AACJ","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Noto+Sans:wght@700&family=Poppins:wght@300;400;500;600&display=swap');\n\n.verification-container\n{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    margin : 0px 20%;\n    margin-top : 80px;\n    background-color: #00468D;\n    border-radius: 10px;\n    padding: 30px 20px;\n}\n\n.verification-title\n{\n    color: white;\n    text-align: center;\n    font-size: 26px;\n    font-weight: 500;\n    margin-bottom : 20px;\n    margin-top : 10px;\n}\n\n.verification-text\n{\n    width : 80%;\n    color: white;\n    text-align: center;\n    margin-bottom: 40px;\n    font-size : 17px;\n}\n\n.verification-code\n{\n    padding : 3px 10px;\n    color: #001E60;\n    font-weight: 500;\n    width : 250px;\n}\n\n.verification-code-container\n{\n    display: flex;\n    align-items: center;\n    margin-bottom : 40px;\n}\n\n.verification-security-text\n{\n    color: white;\n    font-weight : 500;\n    font-size : 16px;\n    margin-right : 12px;\n}\n\n.verification-no-code\n{\n    color: white;\n    margin-bottom : 20px;\n    text-align: center;\n}\n\n.verification-link\n{\n    margin-left : 10px;\n    text-decoration: underline;\n    text-underline-offset: 2px;\n    transition: 300ms ease;\n}\n\n.verification-link:hover\n{\n    color: orange;\n}\n\n.verification-problems-container\n{\n    margin-top : 80px;\n    color : white;\n    align-items: center;\n    margin-bottom : 60px;\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n}\n\n.verification-problems-title\n{\n    font-size : 20px;\n    font-weight: 500;\n    margin-bottom : 30px;\n    text-align: center;\n}\n\n.verification-problems-link\n{\n    text-align: center;\n    font-weight: 600;\n    padding : 10px 20px;\n    background-color: #ecaa1e;\n    color: #001E60;\n    border-radius: 10px;\n    transition: 300ms ease;\n}\n\n.verification-problems-link:hover \n{\n    background-color:#001E60;\n    color: white;\n}\n\n\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button \n{\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n@media all and (max-width : 1000px)\n{\n    .verification-container\n    {\n    margin : 0px 8%;\n    margin-top : 60px;\n    }\n\n    .verification-text\n    {\n        width: 90%;\n    }\n}\n\n@media all and (max-width : 540px)\n{\n    .verification-container\n    {\n    margin : 0px 6%;\n    margin-top : 40px;\n    }\n\n    .verification-text\n    {\n        width: 95%;\n    }\n}\n\n@media all and (max-width : 480px)\n{\n\n    .verification-container\n    {\n        margin : 0px 5%;\n        margin-top : 30px;\n    }\n\n    .verification-title\n    {\n        font-size: 20px;\n    }\n\n    .verification-text\n    {\n        width: 90%;\n        font-size: 15px;\n    }\n\n    .verification-code-container\n    {\n        flex-direction: column;\n    }\n\n    .verification-code\n    {\n        width : 220px\n    }\n\n    .verification-security-text\n    {\n        margin-right : 0px;\n        margin-bottom : 20px;\n    }\n\n    .verification-no-code\n    {\n        display: flex;\n        align-items: center;\n        flex-direction: column;\n        font-size: 13px;\n    }\n\n    .verification-link\n    {\n        margin-left: 0px;\n        margin-top: 5px;\n    }\n\n    .verification-problems-container\n    {\n        margin-top: 40px;\n        margin-bottom : 40px;\n    }\n\n    .verification-problems-title\n    {\n        font-size: 18px;\n    }\n\n    .verification-problems-link\n    {\n        font-size: 14px;\n        padding: 8px 15px;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
